<template>
  <div class="privacy-policy" v-html="$t('company.PRIVACY_POLICY_BODY')">

  </div>
</template>

<script>
import 'styles/main.scss'
export default {
  name: 'terms-of-service',
  data () {
    return {

    }
  }
}
</script>

